// import Navbar from "./components/Navbar"
import Panels from "./components/Panels"
import Canvas from "./components/Canvas"
import Footer from "./components/Footer"
import Toolbox from "./components/Toolbox"
import EditorContainer from "./components/EditorContainer"
import EditorMigrationDialog from "./components/EditorMigrationDialog"
import ContextMenu from "./components/ContextMenu"
import { useEffect, useState } from "react"
import { checkOwnershipByID } from "~/services/chekcProduct"
import { useSelector } from "react-redux"
import { isOwnerSelector } from "~/store/slices/auth/selectors"
import axios from "axios"
import NavbarV2 from "./NavBarV2"
// import Header from "~/components/General/Header"
// @ts-ignore
// import { Header } from "spt-ui-react/output"

interface HeaderProps {
  info: any | false | undefined
  token: string
  logout: () => void
  showHeader: boolean
  showNavbar: boolean
}

const BgSvgSrc = "https://assets1.selfpublishingtitans.com/images/bg.svg"

const Header: React.FC<HeaderProps> = ({ info, token, logout, showHeader = true, showNavbar = true }) => {
  const headerStyle = {
    backgroundImage: `url(${BgSvgSrc})`, // Ensure the correct path to the SVG
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",

    borderBottom: "1.5px solid #ccc",
  }

  const isMobile = useMediaQuery("(max-width: 1024px)")

  const windowLocation = window.location.pathname

  const isBookCoverRoute = windowLocation.includes("book-cover-creator") || windowLocation.includes("A+")

  const isAboutUsRoute = windowLocation.includes("about-us")

  const isSubscribePage = windowLocation.includes("subscribe")

  const isDashboardRoute = windowLocation.includes("dashboard")

  const [HasBanner, setHasBanner] = useState(false)

  const updateHasBanner = (hasBanner: boolean) => {
    setHasBanner(hasBanner)
  }

  const topMargin =
    isAboutUsRoute && HasBanner
      ? "135px"
      : isBookCoverRoute || isAboutUsRoute
      ? "60px"
      : isMobile && HasBanner
      ? "280px"
      : isMobile
      ? "230px"
      : HasBanner
      ? "135px"
      : "70px"

  // const affiliateData = useSelector(
  //   (state: RootState) => state.affiliate.affiliateData
  // );

  // Remove global body class manipulation to prevent CSS conflicts
  // useEffect(() => {
  //   if (isSubscribePage) {
  //     document.body.classList.add("subscribe-page-navbar");
  //   } else {
  //     document.body.classList.remove("subscribe-page-navbar");
  //   }
  // }, [isSubscribePage]);

  // Don't render anything if both header and navbar are hidden
  if (!showHeader && !showNavbar) {
    return null
  }

  return (
    <div className="overflow-visible">
      <div style={{ ...headerStyle, overflow: "visible" }}>
        {showNavbar && <NavbarV2 info={info} logout={logout} />}
        <div
          style={{
            paddingTop: isDashboardRoute ? "0px" : topMargin,
            display: showHeader ? "block" : "none",
          }}
        >
          {/* {children} */}
        </div>
      </div>
    </div>
  )
}

import TUser from "~/models/user"
import { useMediaQuery } from "~/hooks/use-media-query"

const SERVER = import.meta.env.VITE_SERVER_URL

async function fetchInfo(token: string): Promise<TUser> {
  const url = `${SERVER}/api/account`
  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  const info = response.data.data

  return info as TUser
}

const GraphicEditor = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [info, setInfo] = useState<TUser | null>(null)
  const [token, setToken] = useState<string>("")
  const [showMigrationDialog, setShowMigrationDialog] = useState(true)

  const checkToken = async () => {
    const token = sessionStorage.getItem("token")
    if (!token) {
      window.location.href = "/login"
    }

    setToken(token as string)

    const info = await fetchInfo(token as string)
    setInfo(info)
    setIsLoading(false)
  }
  useEffect(() => {
    checkToken()
  }, [])

  if (isLoading) return <div>Loading...</div>

  const logout = () => {
    sessionStorage.removeItem("token")
    window.location.href = "/login"
  }

  return (
    <EditorContainer>
      <EditorMigrationDialog open={showMigrationDialog} onOpenChange={setShowMigrationDialog} />
      {/* @ts-ignore */}
      <div style={{ overflow: "visible" }} className="relative">
        <Header token={token} info={info} logout={logout} showHeader={true} showNavbar={true}></Header>
      </div>
      <div className="text-center  flex items-center justify-center border">
        {/* <Navbar info={info} token="" /> */}
      </div>
      <div style={{ display: "flex", flex: 1 }} className="editor-body-main">
        <Panels />
        <div style={{ flex: 1, display: "flex", flexDirection: "column", position: "relative" }}>
          <Toolbox />
          <Canvas />
          <Footer />
        </div>
      </div>
    </EditorContainer>
  )
}

export default GraphicEditor
